import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { ToastService } from '@motes-sdk/providers';

@Component({
    selector: 'input-field',
    templateUrl: './input-field.component.html',
    styleUrls: ['./input-field.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class InputFieldComponent implements OnInit {

    @Input() input: string = '';
    @Input() placeholder: string = '';
    @Input() id: string = '';
    @Input() copyField: boolean = false;
    /** When true, skip the default “Copied to clipboard” toast (parent can handle via copySuccess). */
    @Input() suppressDefaultCopyToast: boolean = false;
    @Input() characterLimit: number = 524288; // 524288 = default limit: https://www.w3schools.com/tags/att_input_maxlength.asp
    @Input() type = 'text';

    @ViewChild('inputfield') inputField: ElementRef;

    @Output() inputChange = new EventEmitter<string>();
    @Output() inputClear = new EventEmitter<void>();
    @Output() copySuccess = new EventEmitter<void>();

    constructor(private toastService: ToastService) { }

    ngOnInit(): void {
    }

    public onCopySuccess() {
        this.copySuccess.emit();
        if (!this.suppressDefaultCopyToast) {
            this.toastService.addToast($localize`Copied to clipboard`);
        }
    }

    public selectAll() {
        if(!this.copyField) return;
        this.inputField.nativeElement.select();
    }

    public clearInput() {
        this.input = '';
        this.inputChange.emit(this.input);
        this.inputClear.emit();
    }
}
